import { useState } from "react";
import { Ellipsis, Pencil, Trash2 } from "lucide-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import useAuthorized from "hooks/useAuthorized";
import { useVoicemailMutations } from "hooks/useVoicemailTable";
import DeleteVoicemailModal from "routes/voicemail/components/DeleteVoicemailModal";
import VoicemailModal from "routes/voicemail/components/VoicemailModal";

export function VoicemailTableActions({ original }) {
  const canEdit = useAuthorized([ACL_RELATIONSHIPS.voicemail.edit]);
  const canDelete = useAuthorized([ACL_RELATIONSHIPS.voicemail.delete]);
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);

  const { remove } = useVoicemailMutations({
    onDeleted: () => setDeleteOpen(false),
  });

  if (!canEdit && !canDelete) {
    return null;
  }

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger
          aria-label="Voicemail actions"
          className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
        >
          <Ellipsis />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="tw:w-auto">
          {canEdit && (
            <DropdownMenuItem onClick={() => setEditOpen(true)}>
              <Pencil />
              Edit
            </DropdownMenuItem>
          )}
          {canDelete && (
            <DropdownMenuItem
              variant="destructive"
              onClick={() => setDeleteOpen(true)}
            >
              <Trash2 />
              Delete
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
      {canEdit && (
        <VoicemailModal
          model={original}
          open={editOpen}
          onOpenChange={setEditOpen}
        />
      )}
      {canDelete && (
        <DeleteVoicemailModal
          open={deleteOpen}
          onOpenChange={setDeleteOpen}
          onConfirm={() => remove.mutate(original.id)}
        />
      )}
    </>
  );
}
